import { ScreenScrapeProvider } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeProvider';
import { ScreenScrapeLayout } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLayout';
import { ScreenScrapeStepContent } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeStepContent';
import styled, { css } from 'styled-components';
import { Modal, ModalProps } from 'src/common/components/Modal';
import { FC } from 'react';
import { media } from 'src/common/styles/breakpoints';
import { VerificationDTO } from 'src/common/models/verificationModels';
import { PublicAspspItemDTO } from 'src/pages/AspspSelectPage/aspspModels';

const ScreenScrapeModal = styled(Modal)`
  ${media.w.min.px576(css`
    > :first-child {
      width: 30rem;
    }
  `)}
`;
export interface ScreenScrapeProps extends ModalProps {
  processData: VerificationDTO;
  aspsp?: PublicAspspItemDTO;
  isUserReturningToProcess?: boolean;
}

export const ScreenScrape: FC<ScreenScrapeProps> = ({
  processData,
  aspsp,
  isUserReturningToProcess,
  ...props
}) => {
  return (
    <ScreenScrapeModal
      disableEscapeKeyDown={true}
      disableEscapeBackdropClick={true}
      {...props}
    >
      <ScreenScrapeProvider
        isUserReturningToProcess={isUserReturningToProcess}
        wsUrl={processData.openBankingUrl}
        closeModal={props.onClose}
      >
        <ScreenScrapeLayout logo={aspsp?.logo}>
          <ScreenScrapeStepContent />
        </ScreenScrapeLayout>
      </ScreenScrapeProvider>
    </ScreenScrapeModal>
  );
};
